import React, { useState, useEffect } from "react";

export const SorryUser = () => {
  const [pageLoading, setPageLoading] = useState(true);
  useEffect(() => {
    setTimeout(() => {
      setPageLoading(false);
    }, 800);
  }, []);
  return (
    <>
      {pageLoading ? (
        <span className="DishKiChampionsTrophy-loader"></span>
      ) : (
        <div className="winner-container centerElement">
          <div className="winner-header">
            <div className="winner-icon">
              <img src="/Images/happy-face.png" alt="Happy" />
            </div>
            <h2 className="question-title">Thank you!</h2>
            <p>You have already participated in this event.</p>
          </div>
        </div>
      )}
    </>
  );
};
